import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { CURRENT_USER } from '../graphql/queries';
import { useQuery } from '@apollo/client';
import { ICurrentUserOutput } from '../graphql/types/queries/user';
import FullLayoutAnimated from '../components/FullLayoutAnimated';
import { MotivationalQuote } from '../components/MotivationalQuote';

const Container2 = styled(Flex)`
  flex:1;
  flex-direction:column ;
background: rgba(255, 255, 255, 0.45);       // semi-transparent white
  backdrop-filter: blur(10px);               // blur the background behind it
  -webkit-backdrop-filter: blur(10px);       // Safari support
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3); // subtle border
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);  // soft shadow for depth
  @media (max-width: 1050px) {
    background:transparent !important ;
  }
`;
const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #2a3d66;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
const LoadingText = styled(Text)`
  margin-top: 1rem;
  color: #4a5a77;
  font-size: 0.9rem;
`;

function withSession<T>(Component: React.ComponentType<T>) {
  return (props: any) => {
    const { data, loading, refetch, error } = useQuery<ICurrentUserOutput>(CURRENT_USER)

    if (loading || !data) {
      return (
        <FullLayoutAnimated style={{ overflow: 'hidden', zIndex: 10 }}>
          <Flex style={{ width: '100vw', height: '100vh' }}>

            <Container2 alignItems="center" justifyContent="center">
              <Flex alignItems="center" justifyContent="center">
                <MotivationalQuote />
              </Flex>
              <Flex flexDirection={'column'} alignItems="center" justifyContent="center">
                <Spinner />
                <LoadingText>Just a moment while we set things up…</LoadingText>
              </Flex>
            </Container2>
          </Flex>
        </FullLayoutAnimated>
        // <FullLayout>
        //   <Container>
        //     <Flex flex={1}>
        //       <Header dark={false} />
        //     </Flex>
        //     <PleaseWait
        //       text=" ">
        //       <RotatingText />
        //     </PleaseWait>
        //   </Container>
        // </FullLayout>
      );
    }
    if (error) {
      if (error) {
        console.log('err curr', error);
      }
      return null;
    }

    return (
      <Component {...props} session={data.currentUserProvider} refetchSession={refetch} />
    );
  }
}

export default withSession;
